import { useEffect, useState } from "react";
import { usePortableVideoStore } from "@/common/store";
import { useLocation } from "react-router-dom";
import { isSafariDesktop } from "./utils";

export const usePortableVideo = () => {
  const videoRef = usePortableVideoStore((state) => state.videoRef);
  const targetRef = usePortableVideoStore((state) => state.targetRef);
  const videoAttributes = usePortableVideoStore((state) => state.videoAttributes);
  const updateVideo = usePortableVideoStore((state) => state.updateVideo);
  const [videoShown, setVideoShown] = useState<boolean>(false);
  const [videoMounted, setVideoMounted] = useState<boolean>(false);
  const location = useLocation();

  const onMounted: () => void = () => {
    setVideoMounted(true);
  };

  // prevent stop video when changing location and the same video is playing
  useEffect(() => {
    updateVideo({ muted: true });
  }, [location]);

  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    videoRef.current.classList.remove(...videoRef.current.classList);
    targetRef.current?.appendChild(videoRef.current);
  }, [targetRef, videoMounted]);

  useEffect(() => {
    if (targetRef.current !== null) {
      setVideoShown(true);
    }
  }, [targetRef]);

  useEffect(() => {
    if (!videoRef.current || videoRef.current.src !== videoAttributes.src) {
      return;
    }

    videoRef.current.load();
  }, [videoAttributes.src, videoMounted]);

  // Safari desktop doesn't support autoplay, so we need to manually load the video
  useEffect(() => {
    if (!videoRef.current || !isSafariDesktop()) {
      return;
    }

    if (videoAttributes.src) {
      videoRef.current.src = videoAttributes.src;
      videoRef.current.load();
    }
  }, [videoAttributes.src, videoMounted]);

  return {
    videoRef,
    videoAttributes,
    videoShown,
    onMounted
  };
};
